import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCartShopping } from "@fortawesome/free-solid-svg-icons";

interface Props {
  count: number;
  total: number;
  onOpenCart: () => void;
  onPay: () => void;
  isAndroid?: boolean;
  disabled?: boolean;
}

const formatARS = (n: number) =>
  new Intl.NumberFormat("es-AR", { minimumFractionDigits: 2 }).format(n);

export default function CartFooter({
  count,
  total,
  onOpenCart,
  onPay,
  isAndroid,
  disabled,
}: Props) {
  const empty = count === 0;

  return (
    <div className={`mxd-footer${isAndroid ? " mxd-footer--android" : ""}`}>
      {empty ? (
        <p className="mxd-footer-empty">
          Sumá items para ver el total
        </p>
      ) : (
        <div className="mxd-footer-row">
          <button
            type="button"
            className="mxd-footer-summary"
            onClick={onOpenCart}
            aria-label="Ver detalle"
          >
            <span className="mxd-footer-summary-label">
              <FontAwesomeIcon icon={faCartShopping} />
              <span className="mxd-footer-count">{count}</span>
              {count === 1 ? "ítem" : "ítems"}
            </span>
            <span className="mxd-footer-total">${formatARS(total)}</span>
          </button>

          <button
            type="button"
            className="mxd-footer-pay"
            onClick={onPay}
            disabled={disabled}
          >
            Pagar
          </button>
        </div>
      )}
    </div>
  );
}
